var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.id)?_c('router-view'):(_vm.clientLoading)?_c('div',[(_vm.clientLoading)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}):_vm._e()],1):(_vm.clientError)?_c('div',[_c('all-error-inline',{attrs:{"message":_vm.clientError}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }